import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "@/shared/ui/ui";

export interface ArchivePackageDialogProps {
  /** El paquete a archivar, o `null` cuando no hay nada que confirmar. */
  packageName: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

/**
 * La confirmación antes de archivar.
 *
 * Existe porque archivar cambia lo que ve el público y se dispara desde
 * un icono pequeño en una fila entre muchas: el clic equivocado es
 * cuestión de tiempo.
 *
 * El texto dice dos cosas que aquí no son obvias: que NO se borra, y que
 * las suscripciones en marcha siguen cobrándose. Sin la primera frase,
 * "archivar" se lee como "eliminar" y quien administra lo evita —y
 * acaba dejando paquetes muertos publicados—. Sin la segunda, se puede
 * creer que archivar da de baja a quien ya lo contrató, que es lo
 * contrario de lo que pasa.
 */
export function ArchivePackageDialog({
  packageName,
  onConfirm,
  onCancel,
  loading = false,
}: ArchivePackageDialogProps) {
  const { t } = useTranslation();

  if (packageName === null) return null;

  return (
    <ConfirmDialog
      open
      variant="warning"
      title={t("¿Archivar este paquete?")}
      description={t(
        "«{{name}}» dejará de ofrecerse. No se borra, y las suscripciones que ya lo tienen contratado se siguen cobrando.",
        { name: packageName },
      )}
      confirmLabel="Archivar"
      cancelLabel="Cancelar"
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
